export const changelogs = [
    {text: '2026-03-29：加入數學閃卡外部小工具', h: 'https://bestian.github.io/q-flashcard/#/'},
    {text: '2025-11-19：AI家教的內容，表格加入邊框', r: '/ai'},
    {text: '2025-10-23：更新首頁，加入新影片', r: '/'},
    {text: '2025-09-14：升級AI家教的模型與功能，優化回答的品質', r: '/ai'},
    {text: '2025-08-26：修正「數學診療室」正簡轉換時的錯字', r: '/climbing'},
    {text: '2025-08-06：加入社群動態，HomePage的影片更新', r: '/'},
    {text: '2025-08-05：加入硬幣排列小工具', r: '/coins'},
    {text: '2025-05-22：新增「數學診療室」功能', r: '/climbing'},
    {text: '2025-02-21：更新首頁，加入捐款按鈕', h: 'https://www.alearn.org.tw/donate'},
    {text: '2024-07-15：更新首頁，使小秘訣輪播'},
    {text: '2024-07-01：更新《分數到小數》單元。', h: 'https://docs.google.com/document/d/1xr9bhw0qcsio0R3FU9gUOIjW8Ir2mQpAh0fjJh4cnu0/edit'},
    {text: '2024-06-21：新增「倒溯與前推」功能', r: '/trace'},
    {text: '2024-06-17。更新《減法》單元，加入20以內的減法練習' , h: 'https://docs.google.com/document/d/1xrxA_OfzcXkIgMInwXTXy3FAEkkDy4NRTUOkvFnvDMk/edit?usp=sharing'},
    {text:'2024-06-14：首頁改版，加入隨機小秘訣。'},
    {text:'2024-06-13：更新《數線》單元，語句流暢化，符號整齊化，加入大綱', h: 'https://docs.google.com/document/d/1zZIt-DV6TRzENoDAFX3B-_EPISEGL91KCXd7JIofOx0/edit?usp=sharing'},
    {text:'2024-03-02：引入《跟孩子一起玩數學》原名《數學學習診斷法》', r: '/outer'},
    {text: '2023-09-26：引入「切換維基百科」模式，引介學習者至各單位對應的維基百科條目'},
    {text: '2023-09-19：改版摸石頭學習記錄頁面', r:'/log/_'},
    {text: '2023-09-18：新增更新記錄頁面', r: '/changelogs'},
    {text: '2023-09-18：介面優化及除錯'},
    {text: '2023-09-17：將年齡查詢與關鍵字查詢區隔'},
    {text: '2023-09-17：分享按鈕從臉書脫勾，改為複製超連結'},
    {text: '2023-09-15：將教育圖示純化，並且取消灰階，利與查詢'},

]